import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComissionReports } from '../../../components/comission-reports/comission-reports';

@Component({
  selector: 'app-reports-comission',
  standalone: true,
  imports: [
    CommonModule,
    ComissionReports
  ],
  templateUrl: './comission.html',
  styleUrls: ['./comission.scss']
})
export class ReportsComission {
}

